function init() {
	const dates = document.querySelector('.dates');
	const months = [
		'Январь',
		'Февраль',
		'Март',
		'Апрель',
		'Май',
		'Июнь',
		'Июль',
		'Август',
		'Сентябрь',
		'Октябрь',
		'Ноябрь',
		'Декабрь',
	];

	const weeks = [
		'Вс',
		'Пн',
		'Вт',
		'Ср',
		'Чт',
		'Пт',
		'Сб',
	];

	const times = [
		'10:30',
		'11:00',
		'11:30',
		'12:00',
		'12:30',
		'13:00',
		'13:30',
		'14:00',
		'14:30',
		'15:00',
		'15:30',
		'16:00',
		'16:30',
		'17:00',
		'17:30',
		'18:00',
	];

	if (dates) {
		const datesInner = dates.querySelector('.dates__dates');
		const prev = dates.querySelector('.dates__month--prev');
		const next = dates.querySelector('.dates__month--next');
		let allDates;

		const datesMonth = dates.querySelector('.dates__month--name > span');
		const datesYear = dates.querySelector('.dates__month--year');
		const navigations = dates.querySelectorAll('.dates__month--navigation > button');
		let monthText = '';
		let monthIndex = 0;
		let mountCountDay = 0;
		let nowYear = new Date().getFullYear();
		let mowMount = new Date().getMonth();
		let nowDate = new Date();

		months.forEach((el, i) => {
			if (i === mowMount) {
				datesMonth.textContent = el;
				monthIndex = i;
			}
		});

		datesYear.textContent = nowYear;

		mountCountDay = new Date(nowYear, monthIndex + 1, 0).getDate();

		buildCalendar();

		prev.addEventListener('click', () => {
			months.forEach((el, i) => {
				if (el === datesMonth.textContent) {
					i === 0 ? monthText = months[11] : monthText = months[i - 1];
					i === 0 ? monthIndex = 11 : monthIndex = i - 1;
				}
			});

			datesMonth.textContent = monthText;

			mountCountDay = new Date(nowYear, monthIndex + 1, 0).getDate();
		});

		next.addEventListener('click', () => {
			months.forEach((el, i) => {
				if (el === datesMonth.textContent) {
					i === 11 ? monthText = months[0] : monthText = months[i + 1];
					i === 11 ? monthIndex = 0 : monthIndex = i + 1;
				}
			});

			datesMonth.textContent = monthText;

			mountCountDay = new Date(nowYear, monthIndex + 1, 0).getDate();
		});

		navigations.forEach((item) => {
			item.addEventListener('click', () => {
				buildCalendar();
			});
		});

		async function getJson(url) {
			try {
				const data = await fetch(url);
				const json = await data.json();

				return json;
			} catch (e) {
				console.log('JSON not loaded', err);
			}

			return null;
		}

		function tabsTimes() {
			let allTimes = dates.querySelectorAll('.dates__times > .dates__times--item');

			allTimes.forEach((item) => {
				item.addEventListener('click', () => {
					allTimes.forEach((el) => {
						el.classList.remove('dates__times--active');
					});
					if (!item.classList.contains('dates__times--disable')) {
						item.classList.add('dates__times--active');
					}
				});
			});
		}

		async function buildCalendar() {
			let prevMountCountDay = new Date(nowYear, monthIndex, 0).getDate();
			let prevMountAllWeek = [];
			let htmlDays = [];

			if (new Date(nowYear, monthIndex, 1).getDay() != 1) {
				for (let j = prevMountCountDay; j >= 0; j--) {
					if (new Date(nowYear, monthIndex - 1, j).getDay() === 1) {
						prevMountAllWeek.push(j);
					}
				}

				for (let k = prevMountAllWeek[0]; k <= prevMountCountDay; k++) {
					let dayWeeks;
					weeks.forEach((el, i) => {
						if (i === new Date(nowYear, monthIndex - 1, k).getDay()) {
							dayWeeks = el;
						}
					});

					htmlDays.push(`
					<div class='dates__date dates__date--disable'>
						<div class='dates__week'>${dayWeeks}</div>
						<div class='dates__numb'>${k}</div>
					</div>`);
				}
			}
			// console.log(prevMountAllWeek);

			// let prevMountCountDayTwo = prevMountCountDay - 1;
			// let prevDate = [prevMountCountDayTwo, prevMountCountDay];

			// let newMounth = monthIndex - 1;

			// prevDate.forEach((element) => {
			// 	let dayWeeks;

			// 	weeks.forEach((el, i) => {
			// 		if (i === new Date(nowYear, monthIndex - 1, element).getDay()) {
			// 			dayWeeks = el;
			// 		}
			// 	});

			// 	htmlDays.push(`
			// 	<div class='dates__date dates__date--disable'>
			// 		<div class='dates__week'>${dayWeeks}</div>
			// 		<div class='dates__numb'>${element}</div>
			// 	</div>`);
			// });

			// new Date(nowYear, monthIndex, 0).getDate()

			for (let g = 1; g <= mountCountDay; g++) {
				let dayWeeks;
				let dayDisable = false;

				weeks.forEach((el, i) => {
					if (i === new Date(nowYear, monthIndex, g).getDay()) {
						dayWeeks = el;
					}
				});

				if (new Date(nowYear, monthIndex, g).getTime() < nowDate.getTime() - 60 * 60 * 24 * 1000) {
					dayDisable = true;
				}

				let html = `
				<div class='dates__date ${dayDisable ? 'dates__date--disable' : ''}' data-date='${new Date(nowYear, monthIndex, g)}'>
					<div class='dates__week'>${dayWeeks}</div>
					<div class='dates__numb'>${g}</div>
				</div>`;

				htmlDays.push(html);
			}

			let countDate = 35;
			let nextDate = countDate - htmlDays.length;

			for (let t = 1; t <= nextDate; t++) {
				let dayWeeks;
				weeks.forEach((el, i) => {
					if (i === new Date(nowYear, monthIndex + 1, t).getDay()) {
						dayWeeks = el;
					}
				});

				htmlDays.push(`
				<div class='dates__date dates__date--disable'>
					<div class='dates__week'>${dayWeeks}</div>
					<div class='dates__numb'>${t}</div>
				</div>`);
			}

			datesInner.innerHTML = htmlDays.join('');

			const dataJson = await getJson('./times.json');

			allDates = dates.querySelectorAll('.dates__dates > .dates__date');
			const allTimesWrapper = dates.querySelectorAll('.dates__times');

			function getTimeA(time) {
				let numbAr = time.split(':');
				let leftN = Number(numbAr[0]); // 10
				let rightN = Number(numbAr[1]) + 30; // 30

				if (rightN === 60) {
					leftN++;
					rightN = '00';
				}

				let newString = `${leftN} : ${rightN}`;

				return newString;
			}

			allDates.forEach((item) => {
				item.addEventListener('click', () => {
					const allItemsTimes = [];

					allDates.forEach((el) => {
						el.classList.remove('dates__date--active');
					});
					if (!item.classList.contains('dates__date--disable')) {
						item.classList.add('dates__date--active');
					}

					Object.keys(dataJson).forEach((el) => {
						const jsonDataDate = String(new Date(el)).split(' ', 4).join(' ');
						const htmlDataDate = String(new Date(item.getAttribute('data-date'))).split(' ', 4).join(' ');

						if (jsonDataDate === htmlDataDate) {
							dataJson[el].forEach((element) => {
								if (element.isAvailable) {
									allItemsTimes.push(`<a class="dates__times--item">${element.value}</a>`);
								} else {
									allItemsTimes.push(`<a class="dates__times--item dates__times--disable">${element.value}</a>`);
								}
							});

							// times.forEach((time) => {
							// 	dataJson[el].forEach((element) => {
							// 		if (time === element) {
							// 			allItemsTimes.push(`<a class="dates__times--item">${element}</a>`);
							// 		} else {
							// 			allItemsTimes.push(`<a class="dates__times--item dates__times--disable">${time}</a>`);
							// 		}
							// 	});
							// });
						}
					});

					allTimesWrapper.forEach((elem) => {
						elem.innerHTML = allItemsTimes.join('');
					});

					tabsTimes();
				});
			});

			tabsTimes();
		}
	}
}

export default {
	init,
};
